/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { Alert, Badge, Button, Col, Form, InputGroup, Row, } from 'react-bootstrap';
import { FaCheck, FaCircleMinus, FaCirclePlus, FaXmark, } from 'react-icons/fa6';
import { MessagesContext } from '@/pages/_app';
import { cart, layout, generator, format, messages, } from '@/helpers/index';
import { auth } from '@/services/auth';
import Messages from '../messages';

export default function CartComponent({ state }) {
  const router = useRouter();
  const { stateMessages, dispatchMessages } = useContext(MessagesContext);
  const user = auth.store.logged.get();

  const handleCheckout = () => {
    router.push('/carrinho/pagamento');
  };

  const hasPackage = () => state.items.some((el) => el.plan);

  if (!state || state.quantity === 0) {
    return (<span />);
  }
  return (
    <div className="cart" id="cart">
      <Row>
        <Col>
          <Button type="button" className="btn-sm" onClick={() => layout.cart.show(false)}>
            <FaXmark />
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div className="lead text-center">
            Carrinho
            <Badge className="ms-1">
              {state.quantity}
            </Badge>
          </div>
        </Col>
      </Row>
      <hr />
      {state.items.map((row, i) => (
        <Row className="mb-2 overflow-x" key={generator.token()}>
          <Col xs={12} className="d-block d-sm-none">
            <Button type="button" variant="link" size="sm" className="no-padding mb-1" onClick={() => cart.remove(i)}>
              <FaCircleMinus />
            </Button>
            {` ${row.quantity} `}
            <Button type="button" variant="link" size="sm" className="no-padding mb-1" onClick={() => cart.add(i)}>
              <FaCirclePlus />
            </Button>
            {row.discount ? (
              <>
                <span>{row.plan ? ' Pacote de ' : ` ${row.name} de `}</span>
                <s>
                  {format.currency(row.value)}
                </s>
                <span> por </span>
                <strong>
                  {format.currency(row.value - (row.value * row.discount))}
                </strong>
              </>
            )
              : (
                <>
                  <span>{` ${row.name} `}</span>
                  <strong>
                    {format.currency(row.value)}
                  </strong>
                </>
              )}
          </Col>
          <Col xs={6} className="d-none d-sm-block">
            <Button type="button" variant="link" size="sm" onClick={() => cart.remove(i)}>
              <FaCircleMinus />
            </Button>
            {`${row.quantity}`}
            <Button type="button" variant="link" size="sm" onClick={() => cart.add(i)}>
              <FaCirclePlus />
            </Button>
            {row.plan ? <span>{`Pacote ${row.name}`}</span> : <span>{row.name}</span>}
          </Col>
          <Col xs={6} className="d-none d-sm-block text-end">
            {row.discount ? (
              <>
                <span>de </span>
                <s>
                  {format.currency(row.value)}
                </s>
                <span> por </span>
                <strong>
                  {format.currency(row.value - (row.value * row.discount))}
                </strong>
              </>
            )
              : (
                <strong>
                  {format.currency(row.value)}
                </strong>
              )}
          </Col>
        </Row>
      ))}
      <hr />
      <Messages items={stateMessages.messages} clear={messages.clear} />
      <Row>
        <Col>
          <Form onSubmit={cart.coupon}>
            <InputGroup>
              <Form.Control type="text" className="form-control" id="coupon" name="coupon" placeholder={state.coupon ? `${state.coupon.code} = ${state.coupon.discount * 100}%` : 'Digite seu cupom de desconto'} required />
              <Button type="submit" className="btn-sm">Aplicar</Button>
            </InputGroup>
          </Form>
        </Col>
      </Row>
      <hr />
      {!!state.discount && (
        <Row>
          <Col xs={6} className="text-end">Valor total:</Col>
          <Col xs={6} className="fw-bold">{format.currency(state.total)}</Col>
          <Col xs={6} className="text-end">Valor do desconto:</Col>
          <Col xs={6} className="fw-bold">{format.currency(state.discount)}</Col>
        </Row>
      )}
      <Row className="mb-2">
        <Col xs={6} className="text-end">Total a pagar:</Col>
        <Col xs={6}>
          <strong>
            {format.currency(state.balance)}
          </strong>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="text-center">
          {state.balance < 5 && (
            <Alert variant="warning" className="blink-me">
              <span>Valor mínimo da compra: </span>
              <strong>R$ 5,00</strong>
            </Alert>
          )}
          {user?.partner && state.balance < 100 && (
            <Alert variant="warning" className="blink-me">
              <span>Valor mínimo da compra: </span>
              <strong>R$ 100,00</strong>
            </Alert>
          )}
          {user?.partner && hasPackage() && (
            <Alert variant="warning" className="blink-me">
              <span>Pacote não disponível para compra!</span>
            </Alert>
          )}
          <div className="d-grid gap-2">
            <Button variant="success" className="aboutcar-checkout" onClick={handleCheckout} disabled={state.balance < 5}>
              <FaCheck className="me-1" />
              Checkout
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}
